import { Component } from "@angular/core";
import { AuthorizeApi } from "../authorize-api";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-login-menu",
  templateUrl: "./login-menu.component.html",
  styleUrls: ["./login-menu.component.scss"],
})
export class LoginMenuComponent {
  constructor(public api: AuthorizeApi) {}
}
